import {AppThunk} from '../store/types';
import {DashboardStatsResponse} from '../api/apiContracts';
import {getDashboardStats} from '../api/apiClient';
import {setStatsAction} from '../store/stats/actions';

export const loadStats = (): AppThunk<Promise<void>> => async dispatch => {
    const stats: DashboardStatsResponse = await getDashboardStats();
    dispatch(setStatsAction(stats));
};
